import { render } from "./SidebarCollapsableItemWrapper.vue?vue&type=template&id=3c500b91&ts=true"
import script from "./SidebarCollapsableItemWrapper.vue?vue&type=script&lang=ts"
export * from "./SidebarCollapsableItemWrapper.vue?vue&type=script&lang=ts"

import "./SidebarCollapsableItemWrapper.vue?vue&type=style&index=0&id=3c500b91&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__